<template>
    <main>
        <v-dialog
        v-model="modalphotogallery"
        scrollable
        persistent
        width="800"
        >
            <v-card>
                <v-card-title
                class="headline grey lighten-2"
                primary-title
                >
                {{language==='English'?'Upload Photos of my Project':'Subir Fotos de mi Proyecto'}}
                </v-card-title>

                <v-card-text style="height: 350px;">
                    <div class="uploader"
                        @dragenter="OnDragEnter"
                        @dragleave="OnDragLeave"
                        @dragover.prevent
                        @drop="onDrop"
                        :class="{ dragging: isDragging }">
                        
                        <div class="upload-control" v-show="images.length">
                            <label v-if="!isloading" for="file">{{language=='English'?'Select a file':'Seleccionar un Archivo'}}</label>
                            <v-progress-circular 
                                v-else 
                                style="margin-top:10px"     
                                :rotate="-90"
                                :size="40"
                                :width="3"
                                :value="percentageupload"
                                color="primary"
                            >
                                {{ percentageupload }}
                            </v-progress-circular>
                            <!--button @click="upload">{{language==='English'?'Upload':'Subir'}}</button-->
                        </div>


                        <div v-show="!images.length">
                            <v-progress-circular style="margin-top:10px"
                                v-if="isloading"     
                                :rotate="-90"
                                :size="90"
                                :width="3"
                                :value="percentageupload"
                                color="#fff"
                            >
                                {{ percentageupload }}
                            </v-progress-circular>
                            <div v-else>
                                <i class="fa fa-cloud-upload"></i>
                                <p>{{language==='English'?'Drag your images here':'Arrastra tus imágenes aquí'}}</p>
                                <div>{{language==='English'?'OR':'O'}}</div>
                                <div class="file-input">
                                    <label for="file">{{language==='English'?'Select a file':'Seleccion un archivo'}}</label>
                                    <input type="file" id="file" @change="onInputChange">
                                </div>
                            </div>
                        </div>
                        <div class="images-preview" v-show="images.length">

                            <div class="img-wrapper" v-for="(image, index) in images" :key="index">
                                <button type="button" class="close" @click="deletephotoproject(image._id)" style="position:absolute;z-index:5;background:black;">
                                        <span style="color:white;font-size:30px" aria-hidden="true">&times;</span>
                                </button>
                                <img :src="image.link" width="170" height="100" :alt="`Image Uplaoder ${index}`">
                                <!--div class="details">
                                    <span class="name" v-text="files[index].name"></span>
                                    <span class="size" v-text="getFileSize(files[index].size)"></span>
                                </div-->
                            </div>
                        </div>
                    </div>
    
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="#007bff"
                    text
                    @click="modalphotogallery = false"
                    style="color:white"
                >
                    {{language==='English'?'Close':'Cerrar'}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </main>
</template>
<script>
const alertify = require('alertifyjs')
import {EventBus} from '@/helpers/eventbus/event-bus'
import fbstorage from '@/config/fileserver/firebasestorage'
import {ProjectService} from "@/services"


export default {
    data(){
        return{
            modalphotogallery:false,
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            isDragging: false,
            dragCount: 0,
            files: [],
            images: [],
            percentageupload:0,
            isloading:false

        }
    },
    
    mounted(){
        this.getphotosproject()
        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        EventBus.$on('openmodalphotogallery',()=>{
            this.modalphotogallery=true
        })
    
    },
    methods:{
        async deletephotoproject(idphoto){
            try{
                const query = {
                    idproject: this.$route.params.idproject,
                    idphoto: idphoto
                }
                const res = await ProjectService.deletephotoproject(query)
                const {status,data} = res
                if(status===200){
                    this.getphotosproject()
                    //console.log(this.images)
                }
            }catch(err){
                console.log(err)
            }
        },

        async getphotosproject(){
            try{
                const query = {
                    idproject: this.$route.params.idproject
                }
                const res = await ProjectService.getphotosproject(query)
                const {status,data} = res
                if(status===200){
                    this.images = data.photosproject
                    this.$emit('updatedphoto', this.images)
                    //EventBus.$emit('getphotosproject',(this.images))
                }
            }catch(err){
                console.log(err)
                this.images = []
            }
        },
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        OnDragEnter(e) {
            e.preventDefault();
            
            this.dragCount++;
            this.isDragging = true;
            return false;
        },
        OnDragLeave(e) {
            e.preventDefault();
            this.dragCount--;
            if (this.dragCount <= 0)
                this.isDragging = false;
        },
        onInputChange(e) {
            const files = e.target.files;
            Array.from(files).forEach(file => this.addImage(file));
        },
        onDrop(e) {
            if(this.isloading===true){
                e.preventDefault();
                e.stopPropagation();
                if(e.dataTransfer.files.length===1){
                    this.isDragging = false;
                    const files = e.dataTransfer.files;
                    Array.from(files).forEach(file => this.addImage(file));
                }else{
                    this.isDragging = false;
                    alertify.error(this.language==='Envlish'?'You can only upload one file':'Solo puedes subir un archivo')
                }
            }
            this.isDragging = false
            
        },
        getFileExtension(filename) {
            return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
        },
        addImage(file) {
            const query = {
                idproject:this.$route.params.idproject
            }
            ProjectService.limituploadphotoproject(query).then(res=>{
                if (!file.type.match('image.*')) {
                     alertify.error(`${file.name} is not an image`);
                    return
                }
                let iduser = JSON.parse(localStorage.getItem('iden'))._id
                let idproject = this.$route.params.idproject
                let self = this
                let name = self.makeid(6)
                let ext = this.getFileExtension(file.name)
                
                if(ext!==''){
                const storageRef = fbstorage.ref(`${iduser}/projects/${idproject}/${name}.${ext}`)
                const task = storageRef.put(file)
                this.isloading = true
                task.on('state_changed',snapshot=>{
                    let percentage = (snapshot.bytesTransferred/snapshot.totalBytes)*100
                    self.percentageupload = percentage.toFixed(0)
                },(error)=>{
                    alertify.error(error)
                    this.isloading = false
                },
                ()=>{
                
                    task.snapshot.ref.getDownloadURL().then(url => {
                    let imgdata = {
                    name : name+'.'+ext,
                    link: url,
                    _id_project: idproject
                    }
                    //self.fileuploadpost = imgdata
                    ProjectService.savephotosproject(imgdata).then(res=>{
                        //this.getphoto()
                        self.percentageupload = 0
                        this.getphotosproject()
                        //EventBus.$emit('getphotosproject',(this.images))
                        this.isloading = false
                        //self.uploadingfile = false
                    //this.axios.put(`users/edituser/${id}/${self.emailedit}/${self.usernameedit}/${self.passwordempty}/${token}`, self.users)
                    //.then(() =>{
                        
                        //this.getuser()
                        //EventBus.$emit('getuser')
                        //console.log(res)
                        //this.successedit= true
                        /*
                        if(this.passwordedit === true){
                        this.messageedit = 'Datos Editados'
                        }else{
                        this.messageedit = 'Datos Editados'
                        }*/
                        

                    })

                    .catch((err) =>{
                        self.percentageupload = 0
                        //self.uploadingfile = false
                    })
                    //self.percentage = 100
                    //self.loadingsaving = false
                    //self.modalfileuploaded = false
                    //this.filesproject = new FilesProjects()

                    })
                })
                }
                    

            })

            .catch((err) =>{
                 let msg = err.response.data.message

                  if (msg === "deny upload") {
                      alertify.error(this.language==='English'?'You can only upload less than 4 photos in your project.':'Solo puede subir menos de 4 fotos en tu proyecto.')
                  }
            })
           
            /*
            this.files.push(file);
            const img = new Image(),
                reader = new FileReader();
            reader.onload = (e) => this.images.push(e.target.result);
            reader.readAsDataURL(file);*/
        },
        getFileSize(size) {
            const fSExt = ['Bytes', 'KB', 'MB', 'GB'];
            let i = 0;
            
            while(size > 900) {
                size /= 1024;
                i++;
            }
            return `${(Math.round(size * 100) / 100)} ${fSExt[i]}`;
        },
        upload() {
            const formData = new FormData();
            
            this.files.forEach(file => {
                formData.append('images[]', file, file.name);
            });
            axios.post('/images-upload', formData)
                .then(response => {
                    this.$toastr.s('All images uplaoded successfully');
                    this.images = [];
                    this.files = [];
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.uploader {
    width: 100%;
    background: #007bff;
    color: #fff;
    padding: 40px 15px;
    text-align: center;
    border-radius: 10px;
    border: 3px dashed #fff;
    font-size: 20px;
    position: relative;
    &.dragging {
        background: #fff;
        color: #2196F3;
        border: 3px dashed #007bff;
        .file-input label {
            background: #007bff;
            color: #fff;
        }
    }
    i {
        font-size: 85px;
    }
    .file-input {
        width: 200px;
        margin: auto;
        height: 68px;
        position: relative;
        label,
        input {
            background: #fff;
            color: #007bff;
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
            padding: 10px;
            border-radius: 4px;
            margin-top: 7px;
            cursor: pointer;
        }
        input {
            opacity: 0;
            z-index: -2;
        }
    }
    .images-preview {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
         justify-content: center;
        .img-wrapper {
            width: 160px;
            display: flex;
            flex-direction: column;
            margin: 10px;
            height: 100px;
            justify-content: space-between;
            background: #fff;
            box-shadow: 5px 5px 20px #3e3737;
            img {
                max-height: 105px;
            }
        }
        .details {
            font-size: 12px;
            background: #fff;
            color: #000;
            display: flex;
            flex-direction: column;
            align-items: self-start;
            padding: 3px 6px;
            .name {
                overflow: hidden;
                height: 18px;
            }
        }
    }
    .upload-control {
        position: absolute;
        width: 100%;
        background: #fff;
        top: 0;
        left: 0;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
        padding: 10px;
        padding-bottom: 4px;
        text-align: right;
        button, label {
            background: #007bff;
            border: 2px solid #007bff;
            border-radius: 3px;
            color: #fff;
            font-size: 15px;
            cursor: pointer;
        }
        label {
            padding: 2px 5px;
            margin-right: 10px;
        }
    }
}
</style>